import React, { useState, useEffect } from "react";

import styles from "./customerNotes.module.css";

const CustomerNotes = ({ initialNote = "", onSave }) => {
  const [noteText, setNoteText] = useState(initialNote);
  const [saving, setSaving] = useState(false);
  const [justSaved, setJustSaved] = useState(false);

  // Keep the field in sync when the booking (re)loads
  useEffect(() => {
    setNoteText(initialNote);
  }, [initialNote]);

  const dirty = noteText !== (initialNote || "");

  const save = async () => {
    setSaving(true);
    try {
      await onSave(noteText);
      setJustSaved(true);
    } catch (error) {
      console.error("Error saving note:", error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={styles.wrapper}>
      <label htmlFor="customerNotes" className={styles.label}>
        Have a special request or anything we should know about your rental? 
      </label>
      <textarea
        id="customerNotes"
        className={`form-control ${styles.textarea}`}
        rows="4"
        placeholder="Type your notes here…"
        value={noteText}
        onChange={(e) => {
          setNoteText(e.target.value);
          setJustSaved(false);
        }}
      />
      <div className={styles.actions}>
        {justSaved && !dirty && <span className={styles.saved}>✓ Saved</span>}
        <button
          className="btn btn-primary"
          onClick={save}
          disabled={!dirty || saving}
        >
          {saving ? "Saving…" : "Save Note"}
        </button>
      </div>
    </div>
  );
};

export default CustomerNotes;
